// Get Users

import Users from '@/services/Users'
export default {
    data() {
        return {
            users: []
        }
    },
    methods: {
        getUsers() {
             Users.getUsers().then(res => {
                this.users = res.data
             })
         },
    }
}